import React from "react"
import { IconSeeker } from "@ui-seeker/core"
import { Typography } from "@mui/material"

export default function SectionDivider({ title, icon }) {

	return <Typography
		variant="h5"
		sx={{
			display: 'flex',
			gap: .8,
			alignItems: 'center',
			py: 1,
			pr: 2,
			borderBottom: "2px solid",
			color: "secondary.main",
			borderColor: "secondary.main"
		}}>
		<IconSeeker icon={icon} iconWeight="solid" sx={{ fontSize: "1.4rem", color: "primary.main" }}/>
		{title}
	</Typography>
}